import { useEventListeners } from '@deathbyjer/react-event-manager'
import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import useDragToSelect from './hooks/useDragToSelect'
import { Tools } from './toolbar/Tools'

const DocumentAreaWrapper = ({ children }) => {
  const documentAreaRef = useRef(null)
  const documentAreaWrapperRef = useRef(null)
  const activeToolName = useSelector(({ tools }) => tools.active)
  const tool = Tools[activeToolName]

  useEventListeners({
    scrollToPage: (pageId) => {
      const curPage = document.getElementById(`page-${pageId}`)
      documentAreaRef.current.scrollTo({
        top: curPage.offsetTop,
        behavior: 'smooth',
      })
    },
    scrollToField: (pageId) => {
      const curPage = document.getElementById(`page-${pageId}`)
      const curElSelected = curPage.querySelector('.draw-area-selected')
      documentAreaRef.current.scrollTo({
        top: curPage.offsetTop + curElSelected?.offsetTop - 100,
        behavior: 'smooth',
      })
    },
  })

  const { onMouseDown, onMouseMove } = useDragToSelect({
    scrollRef: documentAreaRef,
    containerRef: documentAreaWrapperRef,
    enabled: tool?.dragToSelect,
  })

  return (
    <div ref={documentAreaRef} className="document-area-wrapper scrollable">
      <div
        ref={documentAreaWrapperRef}
        className="document-area-wrapper-body"
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
      >
        {children}
      </div>
    </div>
  )
}

export default DocumentAreaWrapper
